// extracted by mini-css-extract-plugin
module.exports = {"section":"ExitPickTour-section-xKaZj","h1":"ExitPickTour-h1-kHHVi","h1Spanish":"ExitPickTour-h1Spanish-1U3_p","p":"ExitPickTour-p-tEjcO","button":"ExitPickTour-button-2_1CR"};